import { useState, useCallback } from "react";
import appConfig from "../config/app-config";
import axios from "axios";

export default function useApiRequest() {
  const [error, setError] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const apiRequest = useCallback(async (method, url, values?, type?) => {
    try {
      setIsProcessing(true);
      setError(false);
      const result = await axios({
        method: method,
        url: appConfig.baseUrl + url,
        data: values,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      setIsProcessing(false);
      return result;
    } catch (err) {
      setError(true);
      setIsProcessing(false);
      throw err;
    }
  }, []);

  return { apiRequest, error, isProcessing };
}
